<template>
  <sh-fieldset>

    <div class="check-button-container">
      <check-button
        v-for="category in categories"
        v-model="selectedCategories"
        :key="category.id"
        :value="category.id"
        :icon="getIcon(category)"
      >{{ category.name || category.categoryName }}</check-button>
    </div>

  </sh-fieldset>
</template>

<script>
import CheckButton from '~/components/check-button'
import ShFieldset from '~/components/fieldsets'

export default {
  components: {
    CheckButton,
    ShFieldset
  },

  props: {
    categories: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },

  computed: {
    selectedCategories: {
      get () {
        return this.value
      },

      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  methods: {
    getIcon (category) {
      if (category.icon) {
        return category.icon.svg || 'soho'
      }
      if (category.categoryIcon) {
        return category.categoryIcon.svg || 'soho'
      }
      return 'soho'
    }
  }

}
</script>
